"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SizerState = void 0;
const tslib_1 = require("tslib");
const rsync = tslib_1.__importStar(require("../../utils/rsync"));
/**
 * State container for the {@link Sizer} component. Holds the desired content
 * width, the measured container width, and a flag for whether a divider is
 * being dragged. Construct one externally and pass it to {@link Sizer} via
 * the `state` prop to read/write content width or container width from the
 * outside.
 */
class SizerState {
    constructor(initialContent = 800) {
        /** Container width in pixels. */
        this.width = rsync.val(0);
        /** Container element box (position + size). */
        this.box = new rsync.ElBox();
        /** Whether one of the dividers is currently being dragged. */
        this.dragging = rsync.val(false);
        this.content = rsync.val(initialContent);
        this._unsub = this.box.subscribe(() => {
            const w = this.box.value[2];
            if (w !== this.width.value)
                this.width.next(w);
        });
    }
    dispose() {
        this._unsub();
        this.box.dispose();
    }
}
exports.SizerState = SizerState;
